import { useContext } from 'react'

import { ModalPromptContext, ModalPromptContextType } from '../contexts/ModalPromptProvider'

export const useModalPrompt = () => useContext( ModalPromptContext ) as ModalPromptContextType